import "../scss/main.scss";
import { load } from "./load";

load();
